import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { useZed } from '@modules/core/src/react/useZed';
import { StandardModule } from '@modules/standard/src/StandardModule';
import { useEffect, useState } from 'react';

import { FacilityGuiResponse } from '../ecs/component/response/Facility';
import { TourDanjiModule } from '../TourDanjiModule';

import { getItemStyle, GUIView, preUpdateGUI } from './GUIUtiles';

export function FacilityView({}: {}) {
  const zed = useZed<[BabylonjsModule, StandardModule, TourDanjiModule]>();
  const [facilityGUIs, setFacilityGUIs] = useState<FacilityGuiResponse[]>([]);

  useEffect(() => {
    if (!zed) return;

    zed.api.observer.onFacilityLoaded.addOnce(() => {
      zed.api.observer.onUpdateFacilityGUI.add((data) => {
        setFacilityGUIs(JSON.parse(JSON.stringify(data)));

        data.map((item, index) => {
          preUpdateGUI(document.getElementById(`${item.object.facilityName}${index}`), item);
        });
      });
    });
  }, [zed]);

  return (
    <GUIView>
      {facilityGUIs.map(
        (item, index) =>
          item.isVisible && (
            <div
              key={item.key}
              id={`${item.object.facilityName}${index}`}
              style={getItemStyle({
                x: item.x,
                y: item.y,
                scaleWithCameraDistance: item.iconScaleOffset,
                zIndex: item.zIndex,
              })}>
              <div
                style={{
                  color: 'white',
                  fontSize: '7px',
                  overflow: 'hidden',
                  textShadow: '0px 0px 2px #000',
                }}>
                {item.object.facilityName}
              </div>
            </div>
          )
      )}
    </GUIView>
  );
}
